<template>
	<div style="margin-top: 20px;font-size: 14px;display: flex;align-items: center;">
		<div style="margin-left: 10px;display: flex;align-items: center;">
			<div>全局背景设置</div>
			<div style="display: flex;align-items: center;margin-left: 10px;">
				<div @click="changeSelectType(false,'')"
					:style="{backgroundColor:!checked1 && !checked2 && !checked3?'#8c62ff':'#fff',color:!checked1 && !checked2 && !checked3?'#fff':'#000',border:!checked1 && !checked2 && !checked3?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 68px;text-align: center;cursor: pointer;">
					<span style="scale: 0.85;">无</span>
				</div>
				<div @click="changeSelectType(true,'checked1')"
					:style="{backgroundColor:checked1?'#8c62ff':'#fff',color:checked1?'#fff':'#000',border:checked1?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 68px;text-align: center;cursor: pointer;">
					<span style="scale: 0.85;">纯色背景</span>
				</div>
				<div @click="changeSelectType(true,'checked2')"
					:style="{backgroundColor:checked2?'#8c62ff':'#fff',color:checked2?'#fff':'#000',border:checked2?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 68px;text-align: center;cursor: pointer;">
					<span style="scale: 0.85;">渐变背景</span>
				</div>
				<div @click="changeSelectType(true,'checked3')"
					:style="{backgroundColor:checked3?'#8c62ff':'#fff',color:checked3?'#fff':'#000',border:checked3?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="border: solid 1px #959595;padding: 4px 0px;width: 68px;text-align: center;cursor: pointer;">
					<span style="scale: 0.85;">图片背景</span>
				</div>
			</div>
		</div>
		<div v-if="checked1" style="display: flex;align-items: center;margin-left: 10px;">
			<div>背景纯色设置</div>
			<el-color-picker  size="small" style="margin-left: 10px;" v-model="dataItem.singleBgColor.bgColor"></el-color-picker>
		</div>
		<div v-if="checked2" style="display: flex;align-items: center;margin-left: 10px;">
			<div>背景渐变设置</div>
			<div style="margin-left: 10px;">
				<div style="display: flex;flex-direction: column;">
					<el-input
					size="small"
					style="width: 260px;margin-top: 4px;"
					  type="textarea"
					  :rows="1"
					  placeholder="请输入内容"
					  v-model="dataItem.bgColor.bgColor">
					</el-input>
				</div>
				<div style="margin-top: 6px;font-size: 12px;color: #55aaff;transform: scale(0.85);">
					需要自定义模板设置请访问 <a target="_blank" style="margin-left: 4px;"  href="https://www.eggradients.com/gradient-maker">gradient-maker</a> 
				</div>
			</div>
		</div>
		<div v-if="checked3" style="display: flex;align-items: center;margin-left: 10px;">
			<div>背景图片设置</div>
			<div style="display: flex;align-items: center;margin-left: 10px;cursor: pointer;">
				<div v-if="dataItem.bgImg.url == ''" @click="dialogVisibleImgs = true"
					style="width: 60px;height: 60px;border: solid 1px #cacaca ;border-radius: 10px;display: flex;align-items: center;justify-content: center;">
					<i style="font-size: 20px;" class="el-icon-plus"></i>
				</div>
				<div v-if="dataItem.bgImg.url != ''"
					style="border: solid 1px #cacaca ;border-radius: 10px;position: relative;width: 60px;height: 60px;">
					<img @mouseleave="mask = false" @mouseenter="mask = true"
						style="width: 60px;height: 60px;position: absolute;z-index: 1;border-radius: 10px;"
						@click="dialogVisibleImgs = true" :src="dataItem.bgImg.url" />
					<div @mouseleave="mask = false" @mouseenter="mask = true" v-show="mask"
						style="width: 60px;height: 60px;background-color: #000;opacity: 0.6;position: absolute;z-index: 10;border-radius: 6px; display: flex;align-items: center;justify-content: center;font-size: 20px;">
		
					</div>
					<div @mouseleave="mask = false" @mouseenter="mask = true" v-show="mask"
						style="color: #fff;width: 60px;height: 60px;position: absolute;z-index: 100;border-radius: 10px;display: flex;align-items: center;justify-content: center;font-size: 20px;">
						<i @click="dialogVisibleImgs = true" class="el-icon-picture"></i>
						<i @click="dataItem.bgImg.url = ''" style="margin-left: 20px;" class="el-icon-delete"></i>
					</div>
				</div>
			</div>
			<div>
				<div style="display: flex;align-items: center;margin-left: 10px;">
					<div>
						背景重复
					</div>
					<el-select size="mini" @change="changeSelect" style="margin-left: 10px;width: 120px;" v-model="dataItem.bgImg.type" filterable
						allow-create default-first-option placeholder="渲染方式">
						<el-option label="x轴重复" value="repeat-x">
						</el-option>
						<el-option label="y轴重复" value="repeat-y">
						</el-option>
						<el-option label="平铺" value="">
						</el-option>
						<el-option label="不平铺" value="no-repeat">
						</el-option>
					</el-select>
				</div>
				<div style="display: flex;align-items: center;margin-left: 10px;margin-top: 10px;">
					<div>
						背景位置
					</div>
					<el-select size="mini" @change="changeSelect" style="margin-left: 10px;width: 120px;" v-model="dataItem.bgImg.position"
						filterable allow-create default-first-option placeholder="图片位置">
						<el-option label="左上方" value="top left">
						</el-option>
						<el-option label="上中间" value="top center">
						</el-option>
						<el-option label="右上方" value="top right">
						</el-option>
						<el-option label="左中方" value="center left">
						</el-option>
						<el-option label="居中" value="center center">
						</el-option>
						<el-option label="右中方" value="center right">
						</el-option>
						<el-option label="下左方" value="bottom left">
						</el-option>
						<el-option label="下居中" value="bottom center">
						</el-option>
						<el-option label="下右方" value="bottom right">
						</el-option>
					</el-select>
				</div>
			</div>
			<div style="display: flex;flex-direction: column;margin-left: 4px;">
				<el-input size="mini" onkeyup="this.value=this.value.replace(/\D/g,'')" style="width: 160px;" v-model="dataItem.bgImg.width" placeholder="自定义宽度">
					 <template slot="append">px</template>
				</el-input>
				<el-input size="mini" onkeyup="this.value=this.value.replace(/\D/g,'')" style="width: 160px;margin-top: 10px;" v-model="dataItem.bgImg.height" placeholder="自定义高度">
					 <template slot="append">px</template>
				</el-input>
			</div>
			<el-dialog custom-class="select-imgs" title="文件管理器" :visible.sync="dialogVisibleImgs" width="80%"
				:before-close="()=>{dialogVisibleImgs = false}">
				<select-img style="height: 70vh" @confirmImg="confirmSelectImg($event,'dialogVisibleImgs',dataItem.bgImg)"
					v-if="dialogVisibleImgs"></select-img>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import selectImg from '../components/selectImg.vue'
	export default {
		components: {
			selectImg
		},
		props: {
			dataItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
			name: {
				type: Object,
				default: () => {
					return {
						boxBgImg: "bgImg",
						boxColor: "bgColor",
						boxSingleBgColor: "bgImg",
					}
				}
			},
		},
		data() {
			return {
				bgOptions:[
					{
						
						label:"模板1",
						value:'background-image: linear-gradient(120deg, #d4fc79 0%, #96e6a1 100%);'
					},
					{
						
						label:"模板2",
						value:'background: rgb(30,144,255);background: linear-gradient(159deg, rgba(30,144,255,1) 0%, rgba(153,186,221,1) 100%);'
					},
					{
						
						label:"模板3",
						value:'background-image: linear-gradient(120deg, #a6c0fe 0%, #f68084 100%);'
					},
					{
						
						label:"模板4",
						value:'background-image: linear-gradient(120deg, #f093fb 0%, #f5576c 100%);'
					},
					{
						
						label:"模板5",
						value:'background-image: linear-gradient(120deg, #e0c3fc 0%, #8ec5fc 100%);'
					},
				],
				checked1: false,
				checked2: false,
				checked3: false,
				mask: false,
				dialogVisibleImgs: false
			}
		},
		mounted() {
			console.log('this.dataItem',this.dataItem)
			if(this.dataItem.bgType){
				this[this.dataItem.bgType] = true
			}
		},
		methods: {
			changeSelectBg(e,dataItem) {
				dataItem.bgColor = e
				console.log('ee',e)
				
			},
			getStyle(item,index) {
				let op = document.getElementById("op" + index);
				console.log('op',op)
				// if(item) {
				// 	let arr = item.value.split(":")
				// 	let style = {}
				// 	style[arr[0]] = arr[1]
				// 	console.log('getSarrtyle',style)
				// 	return style
				// }
				// return {
				// 	item.value
				// }
			},
			changeSelectType(e, field) {
				console.log('e', e)
				
					this.checked1 = false
					this.checked2 = false
					this.checked3 = false
				if (e) {
					this[field] = true
					this.dataItem.bgType = field
				}else {
					
					this.dataItem.bgType = ''
				}
				console.log('this.dataItem',this.dataItem)
			},
			changeSelect() {
				this.mask = !this.mask
				this.$nextTick(() => {
					this.mask = !this.mask
				})
				console.log('mask', this.mask)
			},
			httpRequest() {

			},
			confirmSelectImg(e, type, dataItem) {
				dataItem.url = e.url
				this.dialogVisibleImgs = false
				this.mask = false
				console.log('e', e)
			},
			ipt(e, field) {
				e[field] = e[field].replace(/\D/g, '')
			},
			changeIpt(e) {}
		}
	}
</script>

<style scoped lang="scss">
	::v-deep .el-input__inner:focus {
		border-color: #242754
	}
</style>